// extracted by mini-css-extract-plugin
export default {"root":"IconSpinner_root__-0ekU"};